module.exports = __webpack_public_path__ + "static/img/elegantManners4.9c4213c7.png";